/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArrowsV = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m12 2 .999.999L13 3l4.707 4.707-1.414 1.414L13 5.828v12.465L16.293 15l1.414 1.414L12 22.121l-5.707-5.707L7.707 15 11 18.293V5.828L7.707 9.121 6.293 7.707 11 3l.001-.001z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgArrowsV as ArrowsV };
